/** localStorage 中 H5 匿名用户标识，与 activity2 / activity3-1 一致 */
export const SIGNSTORE_H5_UID_KEY = 'signstore_h5_uid'

function randomH5Uid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return 'h5_' + Date.now() + '_' + Math.random().toString(36).slice(2, 12)
}

/**
 * 获取或生成 H5 匿名用户 id：优先 URL query，其次 localStorage，否则新建并持久化。
 * @param {string} [fromQuery] 路由上的 h5_uid
 * @returns {string}
 */
export function ensureSignstoreH5Uid(fromQuery) {
  const q = fromQuery != null ? String(fromQuery).trim() : ''
  if (typeof window === 'undefined' || !window.localStorage) {
    return q || randomH5Uid()
  }
  if (q) {
    window.localStorage.setItem(SIGNSTORE_H5_UID_KEY, q)
    return q
  }
  const stored = window.localStorage.getItem(SIGNSTORE_H5_UID_KEY)
  if (stored != null && String(stored).trim() !== '') {
    return String(stored).trim()
  }
  const id = randomH5Uid()
  window.localStorage.setItem(SIGNSTORE_H5_UID_KEY, id)
  return id
}

